import { Box, Typography } from '@mui/material';

import CuminButton from '@components/Button';

import { useStyles } from './useStyles';

interface IMediaKitComponent {
  slice: any;
}

const MediaKitComponent = ({ slice }: IMediaKitComponent) => {
  const { title, description, ctalink, ctatext } = slice?.primary || {};

  const classes = useStyles();

  const openInNewTab = (url: string) => {
    if (url) {
      const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
      if (newWindow) newWindow.opener = null;
    }
  };

  return (
    <Box className={classes.mainContainer}>
      <Typography variant="h2" align="center" color="garamMasala.main">
        {title}
      </Typography>
      <Typography
        variant="body1"
        align="center"
        color="garamMasala.main"
        m="30px 0"
      >
        {description}
      </Typography>
      <CuminButton
        variant="contained"
        color="cinnamon"
        borderRadius="24"
        textColor="whitePepper.main"
        width="270px"
        height="50"
        onClick={() => openInNewTab(ctalink?.url)}
      >
        {ctatext}
      </CuminButton>

      {/* <Box className={classes.title}>
        <Typography variant="h1" align="center" color="garamMasala.main">
          {title}
        </Typography>
      </Box> */}
    </Box>
  );
};

export default MediaKitComponent;
